import type { ReactNode } from "react";

interface LabeledIcon {
  label: string;
  icon: ReactNode;
}

interface BasicInformationProps {
  chain: LabeledIcon;
  asset: LabeledIcon;
  address: string;
}

const Row = ({ label, value }: { label: string; value: ReactNode }) => (
  <div className="flex items-center justify-between gap-4">
    <span className="shrink-0 text-gray-500 text-sm">{label}</span>
    {value}
  </div>
);

const IconValue = ({ label, icon }: LabeledIcon) => (
  <div className="flex min-w-0 items-center gap-2">
    <div className="flex h-5 w-5 shrink-0 items-center justify-center">
      {icon}
    </div>
    <span className="truncate font-medium text-gray-900 text-sm">{label}</span>
  </div>
);

export const BasicInformation = ({
  chain,
  asset,
  address,
}: BasicInformationProps) => (
  <div className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-white p-4">
    <Row label="Chain" value={<IconValue {...chain} />} />
    <Row label="Asset" value={<IconValue {...asset} />} />
    <Row
      label="Address"
      value={
        <span className="break-all text-right font-medium font-mono text-gray-900 text-sm">
          {address}
        </span>
      }
    />
  </div>
);
